import { SelectItem } from 'primeng/api';
import { StaffAccessStatus } from "../../core";

export class staffAcessLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'All', value: StaffAccessStatus.All },
            { label: 'Active', value: StaffAccessStatus.Active },
            { label: 'Inactive', value: StaffAccessStatus.Inactive }
        ];
    }

    static getTitleById(id: number): string {
        const item = this.getLookup().find(x => x.value === id);
        return item ? item.label : '';
    }
}
